const newDeskTop = () => import('@/views/desk-top/desk-top.vue')
export default {
  path: '/main/newDeskTop',
  name: 'newDeskTop',
  component: newDeskTop,
  children: []
}
